/**
 * Тур по странице Sharing (Доступ).
 * Знакомит пользователя с публичными ссылками шаринга устройств.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'sharing-page',
  name: 'help.tours.sharing.name',
  description: 'help.tours.sharing.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие
    {
      element: '.sharing-page .page-title',
      titleKey: 'help.tours.sharing.welcome.title',
      descriptionKey: 'help.tours.sharing.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Кнопка создания ссылки
    {
      element: '.sharing-page .btn--primary',
      titleKey: 'help.tours.sharing.createButton.title',
      descriptionKey: 'help.tours.sharing.createButton.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 3: Статистика и фильтры по статусу
    {
      element: '.sharing-page .stats-row',
      titleKey: 'help.tours.sharing.stats.title',
      descriptionKey: 'help.tours.sharing.stats.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 4: Поиск
    {
      element: '.sharing-page .search-bar',
      titleKey: 'help.tours.sharing.search.title',
      descriptionKey: 'help.tours.sharing.search.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 5: Список ссылок (сетка карточек)
    {
      element: '.sharing-page .share-grid',
      titleKey: 'help.tours.sharing.list.title',
      descriptionKey: 'help.tours.sharing.list.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 6: Карточка ссылки — статус
    {
      element: '.sharing-page .share-card',
      titleKey: 'help.tours.sharing.card.title',
      descriptionKey: 'help.tours.sharing.card.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 7: Флаги возможностей (пароль/маршруты/топливо)
    {
      element: '.sharing-page .share-card__flags',
      titleKey: 'help.tours.sharing.flags.title',
      descriptionKey: 'help.tours.sharing.flags.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 8: Действия — копировать, журнал, изменить, отозвать
    {
      element: '.sharing-page .share-card__actions',
      titleKey: 'help.tours.sharing.actions.title',
      descriptionKey: 'help.tours.sharing.actions.description',
      side: 'left',
      align: 'end',
    },
  ],
}
